import React, { useState, useEffect } from 'react';

import Panel from '../../../Components/Panel/Panel';
import ExecuteAxios from '../../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import { useContext } from 'react';
import { AuthContext } from '../../../Contexts/auth';
import LoadingIndicator from '../../../Components/LoadingIndicator/LoadingIndicator';

function RulesInsert({
    subjectRuleId,
    selectedsRules,
    setReloadRules
}) {
    const { clientSelected } = useContext(AuthContext);
    const [id, setId] = useState(null)
    const [question, setQuestion] = useState(null);
    const [answer, setAnswer] = useState(null);
    const [isActive, setIsActive] = useState('S')

    const [rulesRecordDetail, setRulesRecordDetail] = useState(null)
    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)
    const [loadingPanel, setLoadingPanel] = useState(false)

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "question", value: question, setter: setQuestion, style: { height: '250px' }, width: '220px' },
        { name: "answer", value: answer, setter: setAnswer, style: { height: '250px' }, width: '220px' },
        { name: "subjectRuleId", value: subjectRuleId, setter: null, isMandatory: 'N', isVisible: 'N' },
        {
            name: "isActive", value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ];

    useEffect(() => {
        getRulesDetail(0)
    }, []);

    useEffect(() => {
        setDetailRecord(selectedsRules)
    }, [selectedsRules]);

    async function setDetailRecord(selectedsRules) {
        if (selectedsRules && selectedsRules.length === 1) {
            setInserting(false)
            setUpdating(false)
            await getRulesDetail(selectedsRules[0])
        } else {
            setUpdating(false)
            ResetVariables.resetVariables(attributeList)
        }
    }

    async function getRulesDetail(selectedUser) {
        const parameters = {
            id: selectedUser
        }
        const rulesRecordsDetail = await ExecuteAxios.api('get', `/condominium-rules/get-condominium-rules-by-id-detail/`, { params: parameters });
        setRulesRecordDetail(rulesRecordsDetail);
        if (rulesRecordsDetail) {
            ApplyAttributes.applyAttributes(rulesRecordsDetail, attributeList, inserting)
        }
    }

    async function putRules() {
        try {
            setLoadingPanel(true)
            const parameters = {
                id: selectedsRules[0],
                question: question,
                answer: answer,
                subjectRuleId: subjectRuleId,
                clientId: clientSelected ?? 0,
                isActive: isActive,
                isStatus: 'A'
            }
            return await ExecuteAxios.api('put', `/condominium-rules/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    async function postRules() {
        try {
            setLoadingPanel(true)
            const parameters = {
                question: question,
                answer: answer,
                subjectRuleId: subjectRuleId,
                clientId: clientSelected ?? 0,
                isActive: isActive,
                isStatus: 'A'
            }
            return await ExecuteAxios.api('post', `/condominium-rules/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    const panelsStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    };

    return (
        <Panel
            style={{ ...panelsStyle }}
            titlePage={'Regra selecionada'}
            setUpdating={setUpdating}
            setInserting={setInserting}
            inserting={inserting}
            updating={updating}
            enableEdit={true}
            canEdit={selectedsRules && selectedsRules.length === 1}
            putFunction={putRules}
            enableNewRecord={true}
            canNewRecord={true}
            postFunction={postRules}
            canViewCRUD={true}
            recordsSelected={[]}
            viewOnlyOneRecordCRUD={false}
            resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
            attributeList={attributeList}
            reloadFilter={
                async () => {
                    setReloadRules(true)
                }
            }
            cancelFunction={
                async () => {
                    await setDetailRecord(selectedsRules)
                }
            }
        >
            <LoadingIndicator loaded={rulesRecordDetail && !loadingPanel} >
                <AutomaticallyListedAttributes
                    list={rulesRecordDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={!inserting && !updating}
                />
            </LoadingIndicator>
        </Panel>
    );
}

export default RulesInsert;